import { render } from "./FlyerProdutos.vue?vue&type=template&id=569ca7c0"
import script from "./FlyerProdutos.vue?vue&type=script&lang=js"
export * from "./FlyerProdutos.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__